import type { SpinProps } from 'antd'
import type { FC } from 'react'
import styled from 'styled-components'
import { Spin } from './spin'

export const FullContainerSpin: FC<SpinProps> = (props) => {
  return (
    <StyledSpinWrapper>
      <Spin {...props} />
    </StyledSpinWrapper>
  )
}

const StyledSpinWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`
